const rolePriority = ['admin', 'noc-admin', 'cdim-admin', 'employee', 'contractor', 'customer', 'visitor'] as const;

/**
 * Returns whether the help feedback modal should show customer-specific copy.
 * The highest-priority known system role wins.
 */
export function shouldShowCustomerHelpCopy(systemRoles: string[]): boolean {
    const highestPriorityRole = rolePriority.find((role) => systemRoles.includes(role));

    return highestPriorityRole === 'customer';
}
